import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getRateCodeUsagePlanDetail } from "actions/rateCodeAction";

const useGetUsagePlanRateCodeDetail = (rateCode, isTrigger = true) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [usagePlan, setUsagePlan] = useState([]);
  useEffect(() => {
    const fetch = () => {
      setLoading(true);
      dispatch(
        getRateCodeUsagePlanDetail(rateCode, {
          callbacks: {
            onSuccess: (result) => {
              setUsagePlan(result);
              setLoading(false);
            },
            onFailed: () => {},
          },
        })
      );
    };

    if (rateCode) {
      fetch();
    }
  }, [rateCode, isTrigger, dispatch]);

  return {
    usagePlan,
    loading,
    setUsagePlan,
  };
};

export default useGetUsagePlanRateCodeDetail;
